module.exports = __webpack_public_path__ + "static/scale-model-of-moss-mansion-museum-in-billings-montana-a650e4585bc2c35d93c894c756218621.png";